import React from "react";
import PropTypes from 'prop-types'
import { Uppy } from '@uppy/core'
import DragDropPlugin from './VideoUploadPlugin'

export default class extends React.Component {
  static propTypes = {
    uppy: PropTypes.instanceOf(Uppy).isRequired
  }

  componentDidMount () {
    const { uppy, dragVideoId } = this.props
    /**
     * May be we should use dynamic id generator. But as there is only
     * one instance of this component, hard coded value will work file for now.
     * Have to go to dynamic behavior once it is used at more than one place.
     */
    const id = 'seekrev:VideoUploadDragDrop'
    uppy.use(DragDropPlugin, { id, target: this.container, dragVideoId })

    this.plugin = uppy.getPlugin(id)
  }

  componentWillUnmount () {
    this.props.uppy.removePlugin(this.plugin)
  }

  render () {
    return <div ref={(container) => {
      this.container = container
    }} />
  }
}



// WEBPACK FOOTER //
// ./src/Components/VideoUpload/VideoUploadDragDrop.js